import { useCallback, useMemo } from 'react';

import qs from 'qs';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { usePageCopy } from '#src/app/pages/psf/promoteOrShare/shared/hooks';
import { useQueryParamValue } from '#src/app/shared/hooks/location';

type Result = ModelHookResult<
	{
		skipLabel: string;
		skipUrl: string;
	},
	{
		handleSkipClick: () => void;
	}
>;

export function usePageFooter(): Result {
	const sourceLocation = useQueryParamValue('source_location');
	const guest = useQueryParamValue('guest');
	const shortDisplayName = useQueryParamValue('short_display_name');
	const {
		data: {
			campaignActionsEnabled,
			petition: { slug },
			chipInAmount,
			chipInCurrencyCode,
		},
	} = usePsfPromoteOrSharePageData();
	const {
		data: { skipLinkText },
	} = usePageCopy();
	const track = useTracking();

	const skipUrl = useMemo(() => {
		if (campaignActionsEnabled) {
			return `/p/${encodeURIComponent(slug)}/actions?source_location=${sourceLocation || 'combo_psf'}`;
		}

		return `/p/${encodeURIComponent(slug)}/psf/share${qs.stringify(
			{
				skip: 1,
				source_location: sourceLocation || 'combo_psf',
				psf_variant: 'combo',
				...(['new', 'existing'].includes(guest || '') ? { from_guest_psf: '1' } : undefined),
				...(shortDisplayName ? { short_display_name: shortDisplayName } : undefined),
				psf_combo_static_amount: chipInAmount,
				psf_combo_static_currency: chipInCurrencyCode,
			},
			{ addQueryPrefix: true },
		)}`;
	}, [slug, campaignActionsEnabled, sourceLocation, guest, shortDisplayName, chipInAmount, chipInCurrencyCode]);

	return {
		data: {
			skipLabel: skipLinkText,
			skipUrl,
		},
		actions: {
			handleSkipClick: useCallback(() => {
				void track('combo_psf_skip', { context: 'psf_combo_promote_or_share' });
			}, [track]),
		},
	};
}
